export default __webpack_public_path__ + "static/media/sm-logo.57228d45.png";